(function (angular, app) {
    "use strict";

    angular.module(app.modules.scoring.name)
       .controller(app.modules.scoring.routes.postaround.controller, PostARoundController)

    PostARoundController.$inject = ["$scope", "$q", "$routeParams", "ngDialog", "$timeout", "$interval"
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
       , app.modules.outing.services.outings
       , app.modules.scoring.services.gamescore
       , app.modules.ui.services.alerts
       , app.modules.common.constants.gameenum
       , app.modules.common.constants.equipmentlist
       , app.modules.common.services.storage
       
    ];

    function PostARoundController($scope, $q, $routeParams, ngDialog, $timeout, $interval
       , ggAppSettings
       , ggFunctions
       , ggOutingSvc
       , ggScoringSvc
       , ggAlertSvc
       , ggGameScoreEnum
       , ggEquipmentList
       , ggStorage
       ) {

        // Assign this to object so it can be updated from watcher
        var ctrl = this;

        // Scopes
        $scope.PopupAlert = new ggAlertSvc.popup;
        $scope.Outing = null;
        $scope.GameScore = [];

        var now = new Date().getTime();

        // On page exit, make sure we save the data.
        $scope.$on('$destroy', function () {
            // Wait, before we leave, save it?
            if ($scope.Temp.isChanged) {
                $scope.f.scoring.clickSaveGameScore(true);
            }

            // Kill the interval timer
            if (angular.isDefined(interval)) {
                $interval.cancel(interval);
                interval = undefined;
            }
        });

        // Interval every 2 seconds to update score.-- so no clicking needed
        var interval;
        interval = $interval(function () {
            var nd = new Date().getTime();
            // at least 2 seconds passed last change
            if ($scope.Temp.saveState.savedOn < $scope.Temp.saveState.changedOn) {
                if (nd - $scope.Temp.saveState.changedOn > 4000) {
                    if ($scope.Temp.isChanged && !$scope.Temp.saveState.saving) {
                        $scope.f.scoring.clickSaveGameScore(true);
                    }
                }
            }
        }, 2000);

        $scope.Temp = {
           isLoaded: false
           , window: ggFunctions.fetchWindowSize()
          , isHoleByHole: true
          , scoreIndex: 0
          , currentHoleNumber: 1
          , isTeamScore: false
          , holes: {
              par: []
          }
          , isChanged: false
          , saveState: {
              saving: false
             , isSaved: false
             , changedOn: now
             , savedOn: now
          }
          , tabIndexType: 9
          , isCombinedScore: false
          , maxHoleScore: 16
          , preferenceSettings : app.Member.Detail.preferenceSettings
          , equipmentList: ggEquipmentList
        }


        $scope.View = {
            tabs: {
                current: 1
               , types: {
                   home: 1
                  , stats: 2
                  , settings: 3
                  , leaderboard: 4
                  , outing: 5
               }
               , isActive: function (tab) {
                   return $scope.View.tabs.current == tab;
               }
               , select: function (tab) {
                   if (tab == $scope.View.tabs.types.home) {
                       if (!$scope.GameScore[0].Temp.gameTee) { // Tee Required
                           tab = $scope.View.tabs.types.settings;
                       }
                   }
                   else if (tab == $scope.View.tabs.types.leaderboard) {
                       $scope.Content.leaderboard.tabs.select(0);
                   }
                   $scope.View.tabs.current = tab;
               }
            }
        }

        $scope.Content = {
            init: function () {

                // Insert new score
                var insertNewScore = function (form) {
                    var gameScoreId = null;
                    // Add a couple items to base for
                    form.isTeamScore = $scope.Temp.isCombinedScore;
                    form.gameTeeId = $scope.GameScore[0].gameTeeId;

                    return ggScoringSvc.score.insertGameScore(form).then(function (data) {
                        if (data && data.status == "201") {
                            $scope.GameScore.push(data.data);
                        }
                        return $q.resolve();
                    }, function (error) {
                        return error;
                    });
                }
                
                var players = $scope.Outing.players;
                var pdata = [];

                // if not every player has a score, create one.
                for (var p = 0; p < players.length; p++) {
                    var is = false;
                    for (var s = 0; s < $scope.Outing.scores.length; s++) {
                        if ($scope.Outing.scores[s].playerId == players[p].id) {
                            is = true;
                        }
                    }
                    if (!is) {
                        var form = {
                            outingId: $scope.Outing.id
                            , teeTimeId: $scope.Outing.teeTime.id
                            , playerId: players[p].id
                            , teamId: players[p].teamId
                        }
                        pdata.push(form);
                    }
                }


                if (pdata.length > 0) {
                    var seq = ggFunctions.qSequence;
                    seq(insertNewScore, pdata).finally(function () {
                        $scope.f.formatScoreObject();

                        $scope.Temp.isLoaded = true;
                        ggFunctions.scrollToTop(0);
                        $scope.View.tabs.select($scope.View.tabs.types.home);
                        ggFunctions.toggleProcessing(false);
                    });
                } else {
                    $scope.Temp.isLoaded = true;
                    ggFunctions.scrollToTop(0);
                    $scope.View.tabs.select($scope.View.tabs.types.home);
                    ggFunctions.toggleProcessing(false);
                }


            }
           , home: {

           }
           , stats: {

           }
           , settings: {

           }
           , leaderboard: {
               gameId: 0
              , tabs: {
                  current: 0
                 , isActive: function (tab) {
                     return $scope.Content.leaderboard.tabs.current == tab;
                 }
                 , select: function (tab) {
                     if (tab > -1) {
                         $scope.Content.leaderboard.gameId = $scope.Outing.game.id;
                     } else {
                         $scope.Content.leaderboard.gameId = 0;
                     }
                     $scope.Content.leaderboard.tabs.current = tab;
                 }
              },
               share: {
                   url: "",
                   open: function () {
                       // Get Leaderboard Token
                       ggOutingSvc.search.fetchOutingToken($scope.Outing.id).then(function (data) {
                           if (data) {
                              $scope.Content.leaderboard.share.url = app.Branding.rootURL + "#" + app.modules.outing.routes.leaderboard.path + "?tk=" + data.data.publicAccessToken;
                               try {
                                   ngDialog.open({
                                       template: "app/outing/controllers/share-modal.html",
                                       closeByEscape: false,
                                       closeByDocument: false,
                                       showClose: true,
                                       className: "slideup alert",
                                       scope: $scope,
                                   });
                               }
                               catch (e) {
                                   console.log(e.toString());
                               }
                           }
                       });
                   },
                   copy: function () { },
                   close: function () {
                       ngDialog.closeAll();
                   }
               }
           }
        }


        $scope.f = {
            formatScoreObject: function () {

                // For each score // add some stats
                for (var g = 0; g < $scope.GameScore.length; g++) {

                    //var defaultScore = angular.copy($scope.GameScore[0]);
                    //$scope.GameScore[g] = angular.merge(defaultScore, $scope.GameScore[g]);

                    var scoreTemp = {
                        differential: null
                       , toPar: null
                       , isComplete: false
                       , isChanged: false
                       , player: {}
                       , gameTee: {}
                       , isActive: true
                    }

                    var wagerTemp = {
                        totalValue1: null
                       , totalValue2: null
                       , totalValue3: null
                       , totalValue4: null
                       , totalValue5: null
                    }


                    // No TeeTimeId
                    if (!$scope.GameScore[g].teeTimeId) {
                        $scope.GameScore[g].teeTimeId = $scope.Outing.teeTime.id;
                    }

                    // Temp object on Game Score so we can destroy it later
                    if (!$scope.GameScore[g].Temp) {
                        $scope.GameScore[g].Temp = scoreTemp;

                        // Add Player and Tee data to Score Temp
                        var players = angular.copy($scope.Outing.players);
                        if (players) {
                            for (var p = 0; p < players.length; p++) {
                                if (players[p].id == $scope.GameScore[g].playerId) {
                                    $scope.GameScore[g].Temp.player = players[p];
                                    break;
                                }
                            }
                        }

                        // Add Tee Info
                        var gameCourse = angular.copy($scope.Outing.gameCourse);
                        if (gameCourse.gameTees) {
                            for (var t = 0; t < gameCourse.gameTees.length; t++) {
                                if (gameCourse.gameTees[t].id == $scope.GameScore[g].gameTeeId) {
                                    $scope.GameScore[g].Temp.gameTee = gameCourse.gameTees[t];
                                    break;
                                }
                            }
                        }
                    }



                    // Is Score Complete?
                    if ($scope.Outing.game.holeType == app.modules.scoring.constants.holesPlayed.eighteenHoles) {
                        if ($scope.GameScore[g].scoredThru == 18) {
                            $scope.GameScore[g].Temp.isComplete = true;
                        }
                    } else {
                        if ($scope.GameScore[g].scoredThru = 9) {
                            $scope.GameScore[g].Temp.isComplete = true;
                        }
                    }

                    // Stats
                    if (!$scope.GameScore[g].stats) {
                        var nhs = new app.modules.scoring.objects.gameHoleScore();
                        $scope.GameScore[g].stats = nhs.stats;
                    }

                    // Wagers
                    if (!$scope.GameScore[g].wagers) {
                        $scope.GameScore[g].wagers = wagerTemp;

                    } else {
                        if (!$scope.GameScore[g].wagers.totalValue1) {
                            $scope.GameScore[g].wagers.totalValue1 = null;
                        }
                        if (!$scope.GameScore[g].wagers.totalValue2) {
                            $scope.GameScore[g].wagers.totalValue2 = null;
                        }
                        if (!$scope.GameScore[g].wagers.totalValue3) {
                            $scope.GameScore[g].wagers.totalValue3 = null;
                        }
                        if (!$scope.GameScore[g].wagers.totalValue4) {
                            $scope.GameScore[g].wagers.totalValue4 = null;
                        }
                        if (!$scope.GameScore[g].wagers.totalValue5) {
                            $scope.GameScore[g].wagers.totalValue5 = null;
                        }
                    }
                }

                // Check for existing hole scores and populate object w/ 18 records in order
                for (var g = 0; g < $scope.GameScore.length; g++) {

                    if (!$scope.GameScore[g].gameHoleScores) {
                        $scope.GameScore[g].gameHoleScores = [];
                    }

                    var aryHoles = $scope.GameScore[g].gameHoleScores; // save current holes to array
                    var len = aryHoles.length;
                    var hn = 0;

                    var hb = []; // Store current hole numbers
                    if (len > 0) {
                        for (var h = 0; h < len; h++) {
                            hb.push(aryHoles[h].holeNumber);
                        }
                    }

                    // Fix Undefinde
                    for (var h = 0; h < len; h++) {
                        var tmpGameHoleScore = new app.modules.scoring.objects.gameHoleScore();
                        aryHoles[h] = angular.merge(tmpGameHoleScore, aryHoles[h]);
                      
                    }

                    // Add missing hole objects
                    for (var h = 0; h < 18; h++) {
                        hn++;
                        if (hb.indexOf(hn) == -1) {
                            var holeScore = new app.modules.scoring.objects.gameHoleScore();
                            holeScore.gameScoreId = $scope.GameScore[g].id;
                            holeScore.holeNumber = hn;
                            holeScore.Temp.isChanged = false;
                            aryHoles.push(holeScore);
                            $scope.GameScore[g].Temp.isChanged = true;
                            $scope.Temp.isChanged = true;
                            $scope.Temp.saveState.changedOn = new Date().getTime();
                        }
                    }

                    // Set Gross = 0 back to null
                    for (var h = 0; h < aryHoles.length; h++) {
                        if (aryHoles[h].gross != "undefined" && aryHoles[h].gross == 0) {
                            aryHoles[h].gross = null;
                        }
                    }

                    // Finally, reorder the holes
                    var arySortedHoles = aryHoles;
                    arySortedHoles.sort(function (a, b) { return a.holeNumber - b.holeNumber });

                    // Save holes to Score object.
                    $scope.GameScore[g].gameHoleScores = arySortedHoles;
                }
            }
           , isMultiPlayer: function () {
               var rv = false;
               var cnt = 0;
               for (var x = 0; x < $scope.GameScore.length; x++) {
                   if ($scope.GameScore[x].Temp && $scope.GameScore[x].Temp.isActive) {
                       cnt++;
                   }
               }
               if (cnt > 1) {
                   rv = true;
               }
               return rv;

           }
           , updateTee: function (gameScoreId, gameTee) {
               var teeIndex = $scope.f.fetchTeeIndex(gameTee.id);
               var scoreIndex = $scope.f.fetchScoreIndex(gameScoreId);

               if (scoreIndex > -1 && teeIndex > -1) {

                   if (gameTee.id != $scope.GameScore[scoreIndex].gameTeeId) {
                       $scope.GameScore[scoreIndex].gameTeeId = gameTee.id;
                       $scope.GameScore[scoreIndex].Temp.gameTee = gameTee;
                       $scope.GameScore[scoreIndex].Temp.isChanged = true;
                       $scope.Temp.isChanged = true;
                       $scope.Temp.saveState.changedOn = new Date().getTime();
                   }

               }
           }
           , closeHoleView: function () {
               ngDialog.closeAll();
               for (var x = 0; x < $scope.GameScore.length; x++) {
                   $scope.f.scoring.preProcessGameHoleScores(x);
               }
           }
           , changeScoreIndex: function (x) {
               $scope.Temp.scoreIndex = x;
           }
           , updateScoreStatus: function (data) {
              var scoreStatus = data.scoreStatus;
              var scoreIndex = $scope.f.fetchScoreIndex(data.score.id);

              if (scoreIndex > -1) {

                 if (scoreStatus != $scope.GameScore[scoreIndex].scoreStatus) {
                    $scope.GameScore[scoreIndex].scoreStatus = scoreStatus;
                    $scope.GameScore[scoreIndex].Temp.isChanged = true;
                    $scope.Temp.isChanged = true;
                    $scope.Temp.saveState.changedOn = new Date().getTime();
                 }
              }
           }
           , getHoleScoreIndex: function (hn) {
               var rn = -1;
               if ($scope.GameScore[0].gameHoleScores && $scope.GameScore[0].gameHoleScores.length > 0) {
                   for (var h = 0; h < $scope.GameScore[0].gameHoleScores.length; h++) {
                       if ($scope.GameScore[0].gameHoleScores[h].holeNumber == hn) {
                           rn = h;
                           break;
                       }
                   }
               }
               return rn;
           }
           , updateHoleNumber: function (data) {
              if ($scope.f.getHoleScoreIndex(data.value) > -1) {
                 $scope.Temp.currentHoleNumber = Number(data.value);
              } else {
                 $scope.Temp.currentHoleNumber = 1;
              }
              if (data.saveScore) {
                  if ($scope.Temp.isChanged && !$scope.Temp.saveState.saving) {
                      $scope.f.scoring.clickSaveGameScore(true);
                  }
              }
           }
           , updateGameHoleScore: function (scoreIndex, holeNumber) { // Desktop Entry toggles that item needs to be saved
               var hindex = $scope.f.getHoleScoreIndex(holeNumber);
               $scope.GameScore[scoreIndex].gameHoleScores[hindex].Temp.isChanged = true; // changed hole
               $scope.GameScore[scoreIndex].Temp.isChanged = true; // changed score
               $scope.Temp.isChanged = true; // changed global
               $scope.Temp.saveState.changedOn = new Date().getTime();


              // Update gross gross
               var grossgross = 0;
               for (var g = 0; g < $scope.GameScore[scoreIndex].gameHoleScores.length; g++) {
                  if ($scope.GameScore[scoreIndex].gameHoleScores[g].gross) {
                     grossgross = $scope.GameScore[scoreIndex].gameHoleScores[g].gross + grossgross;
                  }
               }
               $scope.GameScore[scoreIndex].gross = grossgross;

           }
           , cancelTab: function (e) {
               if (e.keyCode == 9) {
                   e.preventDefault();
               }
           }
           , autoStepScore: function (e, id, scoreIndex, holeNumber) {

               var isStep = false;
               var isTab = false;
               var isTypeChange = false;
               var isNumber = false;

               var oldVal = 0;
               var newVal = 0;
               var oldEl = angular.element(document.querySelector("#" + id + "-" + scoreIndex + '-' + holeNumber));
               var nxtHole = holeNumber + 1;

               if (e.keyCode == 9) {
                   isTab = true;
               }
               if (e.keyCode > 47 && e.keyCode < 58) {
                   isNumber = true;
               }

               if (!isTab) {
                   if (id == "score" && isNumber) {
                       oldVal = $scope.GameScore[scoreIndex].gameHoleScores[holeNumber - 1].gross;
                       newVal = oldEl[0].value;
                       if (newVal < ($scope.Temp.maxHoleScore + 1)) {
                           if (newVal > 1) {
                               isStep = true;
                           }
                       }
                   }

                   if (id == "wager" && isNumber) {
                       oldVal = $scope.GameScore[scoreIndex].gameHoleScores[holeNumber - 1].wagers.value1;
                       newVal = oldEl[0].value;
                       if (newVal > (999)) {
                           //if (newVal > 0) {
                           isStep = true;
                           //}
                       }
                   }

                   if (id == "putt" && isNumber) {
                       oldVal = $scope.GameScore[scoreIndex].gameHoleScores[holeNumber - 1].stats.puttCount;
                       newVal = oldEl[0].value;
                       if (newVal < ($scope.Temp.maxHoleScore + 1)) {
                           //if (newVal > 1) {
                           isStep = true;
                           //}
                       }
                   }

                   if (id == "penalty" && isNumber) {
                       oldVal = $scope.GameScore[scoreIndex].gameHoleScores[holeNumber - 1].stats.penaltyStrokes;
                       newVal = oldEl[0].value;
                       if (newVal < ($scope.Temp.maxHoleScore + 1)) {
                           //if (newVal > 1) {
                           isStep = true;
                           //}
                       }
                   }

                   if (id == "drive" && isNumber) {
                       oldVal = $scope.GameScore[scoreIndex].gameHoleScores[holeNumber - 1].stats.driveDistance;
                       newVal = oldEl[0].value;
                       if (newVal > 99) {
                           isStep = true;
                       }
                   }

                   if (id == "firstputt" && isNumber) {
                       oldVal = $scope.GameScore[scoreIndex].gameHoleScores[holeNumber - 1].stats.puttLength;
                       newVal = oldEl[0].value;
                       if (newVal > 10) {
                           isStep = true;
                       }
                   }
               } else {
                   isStep = true;
               }

               if (isStep) {
                   if ((nxtHole == 10 && $scope.Temp.tabIndexType == 9 && ($scope.Temp.preferenceSettings.trackStats || $scope.Outing.game.isWager)) || (nxtHole > 18 || (nxtHole == 10 && $scope.Outing.game.holeType != app.modules.scoring.constants.holesPlayed.eighteenHoles))) {
                       isTypeChange = true;
                   }
               }


               if (isTypeChange) {
                   // multiplayer
                   // stats
                   // wagers

                   if ($scope.Temp.tabIndexType == 9 && (nxtHole == 10 || nxtHole > 18)) {
                       
                       if ($scope.GameScore.length == 1) {
                          // 9 hole tabs
                          if (nxtHole == 10) {
                             nxtHole = 1;
                          } else {
                             if (nxtHole > 18) {
                                nxtHole = 1;
                             }
                          }
                          if (id == "score") {
                               if ($scope.Outing.game.isWager) {
                                   id = "wager";
                               } else {
                                   if ($scope.Temp.preferenceSettings.trackStats) {
                                       id = "putt";
                                   }
                               }
                           } else {
                               if (id == "wager") {
                                   if ($scope.Temp.preferenceSettings.trackStats) {
                                       id = "putt";
                                   } else {
                                       id = "score";
                                   }
                               } else {
                                   if (id == "putt") {
                                       id = "penalty";
                                   } else {
                                       if (id == "penalty") {
                                           id = "drive";
                                       } else {
                                           if (id == "drive") {
                                               id = "firstputt";
                                           } else {
                                               id = "score";
                                               if (nxtHole == 1) {
                                                   nxtHole = 10;
                                               } else {
                                                   if (nxtHole == 10) {
                                                       nxtHole = 1;
                                                   }
                                               }
                                           }
                                       }
                                   }
                               }
                           }
                       } else {
                          // Multiplayer
                           if (id == "score" && $scope.Outing.game.isWager) {
                              id = "wager";

                              if (nxtHole == 10) {
                                 nxtHole = 1;
                              }
                              if (nxtHole > 18) {
                                 nxtHole = 10;
                              }

                              

                           } else {
                               if (id == "score") {
                                  if (scoreIndex == $scope.GameScore.length - 1) {
                                       scoreIndex = 0;
                                       if (nxtHole > 18) {
                                          nxtHole = 1;
                                       }
                                   } else {
                                     scoreIndex++;
                                     if (nxtHole == 10) {
                                         nxtHole = 1;
                                     }
                                     if (nxtHole > 18) {
                                         nxtHole = 10;
                                     }
                                   }
                               } else {
                                   // wager
                                   id = "score";
                                   if (scoreIndex == $scope.GameScore.length - 1) {
                                      scoreIndex = 0;
                                      if (nxtHole > 18) {
                                         nxtHole = 1;
                                      }
                                       

                                   } else {
                                       scoreIndex++;
                                       if (nxtHole == 10) {
                                          nxtHole = 1;
                                       }
                                       if (nxtHole > 18) {
                                          nxtHole = 10;
                                       }
                                   }

                               }

                           }
                       }

                   } else {
                       // 18 hole tabs
                       if (nxtHole > 18) {
                           nxtHole == 1;
                       }
                       if ($scope.GameScore.length == 1) {
                           if (id == "score") {
                               if ($scope.Outing.game.isWager) {
                                   id = "wager";
                               } else {
                                   if ($scope.Temp.preferenceSettings.trackStats) {
                                       id = "putt";
                                   }
                               }
                           } else {
                               if (id == "wager") {
                                   if ($scope.Temp.preferenceSettings.trackStats) {
                                       id = "putt";
                                   } else {
                                       id = "score";
                                   }
                               } else {
                                   if (id == "putt") {
                                       id = "penalty";
                                   } else {
                                       if (id == "penalty") {
                                           id = "drive";
                                       } else {
                                           if (id == "drive") {
                                               id = "firstputt";
                                           } else {
                                               id = "score";
                                           }
                                       }
                                   }
                               }
                           }
                       } else {
                           if (scoreIndex < $scope.GameScore.length - 1) {
                               scoreIndex++;
                           } else {
                               scoreIndex = 0;
                               if (id == "score") {
                                   if ($scope.Outing.game.isWager) {
                                       id = "wager";
                                   }
                               } else {
                                   id = "score";
                               }
                           }
                       }
                   }
               }



               if (isStep || isTypeChange) {
                   var newEl = angular.element(document.querySelector("#" + id + "-" + scoreIndex + '-' + nxtHole));

                   // Drives disabled on par 3
                   if (newEl[0].isDisabled) {
                       nxtHole++;
                       if (nxtHole > 18) {
                           nxtHole == 1;
                       }
                       newEl = angular.element(document.querySelector("#" + id + "-" + scoreIndex + '-' + nxtHole));
                   }
                   newEl[0].select();

                   if (id == "score") {
                       $scope.f.updateHoleNumber({ value: nxtHole });
                   }

               }

               if (holeNumber == 9 || holeNumber == 18) {
                   $scope.f.updateGameHoleScore(scoreIndex, holeNumber);
               }

           }

            // HoleView Update Callbacks
           , getHoleScoreClass: function (score, hole, holeIndex) {
               var rv = "";
               var gross = score.gameHoleScores[holeIndex].gross;
               if (hole && hole.par && hole.par > 0 && gross && gross > 0) {
                   if (gross < (hole.par - 1)) {
                       rv += " eagle";
                   }
                   if (gross == (hole.par - 1)) {
                       rv += " birdie";
                   }
                   if (gross == (hole.par)) {
                       rv += " par";
                   }
                   if (gross == (hole.par + 1)) {
                       rv += " bogey";
                   }
                   if (gross == (hole.par + 2)) {
                       rv += " double";
                   }
                   if (gross > (hole.par + 2)) {
                       rv += " other";
                   }
               }

               if (score.gameHoleScores[holeIndex].strokes && score.gameHoleScores[holeIndex].strokes > 0) {
                   rv += " stk" + score.gameHoleScores[holeIndex].strokes;
               }


               return rv;
           }
           , getHoleWagerClass: function (holeIndex) {
               var rv = "";
               if ($scope.f.isMultiPlayer()) {
                   var tot = 0;
                   for (var s = 0; s < $scope.GameScore.length; s++) {
                       tot += ($scope.GameScore[s].gameHoleScores[holeIndex].wagers.value1 || 0)
                   }
                   if (tot != 0) {
                       rv = "un";
                   }
               }

               return rv;
           }
           , updateHoleGross: function (data) {

              // HoleNmber, Par, Selected

               var hn = Number(data.holeNumber);
               var hindex = $scope.f.getHoleScoreIndex(hn);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = data.scoreIndex || $scope.Temp.scoreIndex;
               if (isNaN(vl) || vl == "") {
                   vl = 0
               } else {
                   vl = Number(vl);
               }
               if (vl < 0 && pr) { vl = pr + vl; }
               if (vl == 1 && !$scope.GameScore[pi].gameHoleScores[hindex].gross && pr) {
                  vl = pr + 1;
               }
               if (vl < 1) { vl = null; }
               
                if (vl != $scope.GameScore[pi].gameHoleScores[hindex].gross) {
                   $scope.GameScore[pi].gameHoleScores[hindex].gross = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }
           }
           , updateHolePutts: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;
               if ((isNaN(vl) || vl == "") && vl != 0) {
                   vl = null;
               } else {
                   vl = Number(vl);
               }
               if (vl < 0) {
                  vl = null;
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.GameScore[pi].gameHoleScores[hindex].stats.puttCount) {
                   $scope.GameScore[pi].gameHoleScores[hindex].stats.puttCount = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }
           }
           , updateHolePenalties: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;
               if (isNaN(vl) || vl == "") {
                   vl = null;
               } else {
                   vl = Number(vl);
               }
               if (vl < 0) {
                  vl = null;
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.GameScore[pi].gameHoleScores[hindex].stats.penaltyStrokes) {
                   $scope.GameScore[pi].gameHoleScores[hindex].stats.penaltyStrokes = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }
           }
           , updateHoleClub: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;
               if (vl && vl != "") {
                   vl = vl;
               } else {
                   vl = null
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.GameScore[pi].gameHoleScores[hindex].stats.golfClub) {
                   $scope.GameScore[pi].gameHoleScores[hindex].stats.golfClub = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }
           }
           , updateHoleDrive: function () {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;
               if (isNaN(vl) || vl == "") {
                   vl = null;
               } else {
                   vl = Number(vl);
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.GameScore[pi].gameHoleScores[hindex].stats.driveDistance) {
                   $scope.GameScore[pi].gameHoleScores[hindex].stats.driveDistance = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }

           }
           , updateHoleFIR: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;
               if (!vl || vl == "") {
                   vl = null;
               } else {
                   vl = vl;
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.GameScore[pi].gameHoleScores[hindex].stats.fir) {
                   $scope.GameScore[pi].gameHoleScores[hindex].stats.fir = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }


           }
           , updateHoleUpDown: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;

               vl = Number(vl);

               var isChanged = false;
               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl > 0) {
                   if (vl == 1) {
                       // No Value
                       if ($scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownOpportunity) {
                           $scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownOpportunity = null;
                           isChanged = true;
                       }
                       if ($scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownHit) {
                           $scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownHit = null;
                           isChanged = true;
                       }
                   } else {
                       // Opportunity
                       if (!$scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownOpportunity) {
                           $scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownOpportunity = true;
                           isChanged = true;
                       }
                       if (vl == 2) {
                           // Hit
                           if (!$scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownHit) {
                               $scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownHit = true;
                               isChanged = true;
                           }
                       } else {
                           // Missed
                           if ($scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownHit) {
                               $scope.GameScore[pi].gameHoleScores[hindex].stats.upAndDownHit = false;
                               isChanged = true;
                           }
                       }
                   }
               }

               if (isChanged) {
                   $scope.f.updateGameHoleScore(pi, hn);
               }

           }
           , updateHoleSandie: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;

               vl = Number(vl);

               var isChanged = false;
               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl > 0) {
                   if (vl == 1) {
                       // No Value
                       if ($scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveOpportunity) {
                           $scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveOpportunity = null;
                           isChanged = true;
                       }
                       if ($scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveHit) {
                           $scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveHit = null;
                           isChanged = true;
                       }
                   } else {
                       // Opportunity
                       if (!$scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveOpportunity) {
                           $scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveOpportunity = true;
                           isChanged = true;
                       }
                       if (vl == 2) {
                           // Hit
                           if (!$scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveHit) {
                               $scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveHit = true;
                               isChanged = true;
                           }
                       } else {
                           // Missed
                           if ($scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveHit) {
                               $scope.GameScore[pi].gameHoleScores[hindex].stats.sandSaveHit = false;
                               isChanged = true;
                           }
                       }
                   }
               }

               if (isChanged) {
                   $scope.f.updateGameHoleScore(pi, hn);
               }
           }
           , updateHoleFirstPutt: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;
               if (isNaN(vl) || vl == "") {
                   vl = null;
               } else {
                   vl = Number(vl);
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.GameScore[pi].gameHoleScores[hindex].stats.puttLength) {
                   $scope.GameScore[pi].gameHoleScores[hindex].stats.puttLength = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }

           }
           , updateHoleWager: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               var pi = $scope.Temp.scoreIndex;
               if (isNaN(vl) || vl == "") {
                   vl = null;
               } else {
                   vl = Number(vl);
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl && vl != $scope.GameScore[pi].gameHoleScores[hindex].wagers.value1) {
                   $scope.GameScore[pi].gameHoleScores[hindex].wagers.value1 = vl;
                   $scope.f.updateGameHoleScore(pi, hn);
               }
           }
           , fetchPlayerIndex: function (playerId) {
               var i = -1;
               for (var x = 0; x < $scope.Outing.players.length; x++) {
                   var player = $scope.Outing.players[x];
                   if (player.id == playerId) {
                       i = x;
                       break;
                   }
               }
               return i;
           }
           , fetchTeamIndex: function (teamId) {
               var i = -1;
               for (var x = 0; x < $scope.Outing.teeTime.teams.length; x++) {
                   var team = $scope.Outing.teeTime.teams[x];
                   if (team.id == teamId) {
                       i = x;
                       break;
                   }
               }
               return i;
           }
           , fetchTeeIndex: function (gameTeeId) {
               var i = -1;
               for (var x = 0; x < $scope.Outing.gameCourse.gameTees.length; x++) {
                   var gameTee = $scope.Outing.gameCourse.gameTees[x];
                   if (gameTee.id == gameTeeId) {
                       i = x;
                       break;
                   }
               }
               return i;
           }
           , fetchScoreIndex: function (scoreId) {
               var i = -1;
               for (var x = 0; x < $scope.GameScore.length; x++) {
                   if ($scope.GameScore[x].id == scoreId) {
                       i = x;
                       break;
                   }
               }
               return i;
           }

           , format: {
               playDate: function (d) {
                   return ggFunctions.formatDateString(d, "m/d/yyyy", null);
               }
              , number: function (n, d) {
                  if (isNaN(n)) {
                      n = 0;
                  }
                  if (isNaN(d)) {
                      d = 0;
                  }

                  n = Math.round(n, d);

                  return n;
              }
              , percent: function (n) {
                  if (isNaN(n)) {
                      n = 0;
                  } else {
                      n = (n * 100);
                  }

                  n = Math.round(n, 1) + "%"
                  return n;
              }
           }

           , toggle: {
               player: function (playerId) {

                  var isPlayer = false;

                  // You cannot toggle ScoreIndex = 0;
                  var scoreIndex = -1;
                  for (var s = 0; s < $scope.GameScore.length; s++) {
                      if ($scope.GameScore[s].Temp && $scope.GameScore[s].Temp.player.id == playerId) {
                          scoreIndex = s;
                          break;
                      }
                  }

                  if (scoreIndex > 0) {
                      $scope.GameScore[scoreIndex].Temp.isActive = !$scope.GameScore[scoreIndex].Temp.isActive;
                  }
              }
              , isPlayerScoring: function (playerId) {

                  var ips = false;
                  for (var s = 0; s < $scope.GameScore.length; s++) {
                      if ($scope.GameScore[s].Temp && $scope.GameScore[s].Temp.isActive && $scope.GameScore[s].Temp.player.id == playerId) {
                          ips = true;
                          break;
                      }
                  }
                  return ips;
              }

              , team: function (teamId) {

                  var isTeam = false;
                  // Toggling a team just turns scoring on/off for that player.  No change in screen.
                  // You cannot toggle ScoreIndex = 0;

                  // Loop thru game scores to find scoreIndex
                  for (var s = 0; s < $scope.GameScore.length; s++) {
                      if ($scope.GameScore[s].teamId == teamId) {
                          $scope.Temp.scoreIndex = s;
                          isTeam = true;
                      }
                  }

                  // If the player is scoreIndex = 0, we can't toggle off.
                  if (isTeam && $scope.Temp.scoreIndex == 0) {
                      return;
                  }

                  // Team is toggling off.
                  if (isTeam && $scope.Temp.scoreIndex > 0) {
                      $scope.GameScore.splice($scope.Temp.scoreIndex, 1);
                      // Reset back to score 0
                      $scope.Temp.scoreIndex = 0;
                  }

                  if (!isTeam) {

                      var form = {
                          outingId: $scope.Outing.id
                         , teeTimeId: $scope.Outing.teeTime.id
                         , playerId: null
                         , teamId: teamId
                         , gameTeeId: $scope.GameScore[0].gameTeeId
                         , isTeamScore: $scope.Temp.isCombinedScore
                      }

                      var gameScoreId = 0;

                      // check if gameScore already exists
                      ggFunctions.toggleProcessing(true);
                      ggScoringSvc.score.fetchGameScores(form).then(function (data) {
                          if (data && data.status == "200") {
                              if (data.data.value.length > 0) {
                                  // existing game score
                                  gameScoreId = data.data.value[0].id;

                                  return ggScoringSvc.score.fetchGameScoreDetail({ outingId: $scope.Outing.id, gameScoreId: gameScoreId }).then(function (data) {
                                      if (data && data.status == "200") {
                                          if (data.data) {

                                              var newGameScore = data.data;

                                              // Add Team Info
                                              var teeTime = $scope.Outing.teeTime;
                                              if (teeTime.teams) {
                                                  for (var t = 0; t < teeTime.teams.length; t++) {
                                                      var team = teeTime.teams[t];
                                                      if (team.id == teamId) {
                                                          newGameScore.team = team;
                                                          break;
                                                      }
                                                  }
                                              }

                                              // Add Tee Info
                                              var gameCourse = $scope.Outing.gameCourse;
                                              if (gameCourse.gameTees) {
                                                  for (var g = 0; g < gameCourse.gameTees.length; g++) {
                                                      var gameTee = gameCourse.gameTees[g];
                                                      if (gameTee.id == newGameScore.gameTeeId) {
                                                          newGameScore.gameTee = gameTee;
                                                          break;
                                                      }
                                                  }
                                              }

                                              // Push Score into Array
                                              $scope.GameScore.push(newGameScore);
                                              $scope.f.formatScoreObject();

                                              $scope.Temp.scoreIndex = $scope.GameScore.length - 1;

                                          }
                                      }
                                  });

                              } else {
                                  // Insert new game score
                                  return ggScoringSvc.score.insertGameScore(form).then(function (data) {
                                      if (data && data.status == "201") {

                                          gameScoreId = data.data.id;
                                          ggScoringSvc.score.fetchGameScoreDetail({ outingId: $scope.Outing.id, gameScoreId: gameScoreId }).then(function (data) {
                                              if (data && data.status == "200") {
                                                  if (data.data) {

                                                      var newGameScore = data.data;


                                                      // Add Team Info
                                                      var teeTime = $scope.Outing.teeTime;
                                                      if (teeTime.teams) {
                                                          for (var t = 0; t < teeTime.teams.length; t++) {
                                                              var team = teeTime.teams[t];
                                                              if (team.id == teamId) {
                                                                  newGameScore.team = team;
                                                                  break;
                                                              }
                                                          }
                                                      }

                                                      // Add Tee Info
                                                      var gameCourse = $scope.Outing.gameCourse;
                                                      if (gameCourse.gameTees) {
                                                          for (var g = 0; g < gameCourse.gameTees.length; g++) {
                                                              var gameTee = gameCourse.gameTees[g];
                                                              if (gameTee.id == newGameScore.gameTeeId) {
                                                                  newGameScore.gameTee = gameTee;
                                                                  break;
                                                              }
                                                          }
                                                      }

                                                      // Push Score into Array
                                                      $scope.GameScore.push(newGameScore);
                                                      $scope.f.formatScoreObject();


                                                  }
                                              }
                                          });
                                      }
                                  }).finally(function () {
                                      ggFunctions.toggleProcessing(false);
                                  });
                              }
                          }


                      }).finally(function () {
                          ggFunctions.toggleProcessing(false);
                      });

                  }

              }
              , isTeamScoring: function (teamId) {
                  var ips = false;
                  for (var s = 0; s < $scope.GameScore.length; s++) {
                      if ($scope.GameScore[s].teamId == teamId) {
                          ips = true;
                          break;
                      }
                  }
                  return ips;
              }
           }
           , scoring: {
               openHoleView: function (hn) {


                   // Need these items in the Hole View
                   $scope.Temp.currentHoleNumber = hn || 1;
                   $scope.Temp.scoreIndex = 0;

                   // List of Pars
                   $scope.Temp.holes.par = [];
                   for (var p = 0; p < $scope.GameScore[0].Temp.gameTee.gameHoles.length; p++) {
                       $scope.Temp.holes.par.push($scope.GameScore[0].Temp.gameTee.gameHoles[p].par);
                   }

                  
                   app.Member.Session.pageTemplates.fetch(app.modules.scoring.routes.gameholeview.templateUrl).then(function (template) {

                      var _holeViewModal = ngDialog.open({
                         template: template
                         , plain: true
                         , closeByEscape: false
                         , closeByDocument: false
                         , showClose: true
                         , className: "holeview"
                         , scope: $scope
                      });
                   });

               }
              , clickSaveGameScore: function (isBackgroundProcess) { // Button to Save All Scores

                  $scope.Temp.saveState.saving = true;

                  var nd = new Date();

                  // update each score / hole stat 
                  for (var s = 0; s < $scope.GameScore.length; s++) {
                      $scope.f.scoring.preProcessGameHoleScores(s);
                  }

                  // Send the data to the API
                  var save = function () {
                      return $scope.f.scoring.saveFullScore();
                  }

                  // Show processor
                  if (!isBackgroundProcess) {
                      ggFunctions.toggleProcessing(true);
                  }

                  save().finally(function () {
                      ggFunctions.toggleProcessing(false);
                      $scope.Temp.saveState.saving = false;
                      $scope.Temp.saveState.savedOn = new Date().getTime();
                  });

              }
              , preProcessGameHoleScores: function (scoreIndex) { // Recalc each stat for a score
                  return $q(function (resolve) {

                      var score = {
                          gross: 0
                         , net: 0
                         , front9Gross: 0
                         , back9Gross: 0
                         , front9Net: 0
                         , back9Net: 0
                         , scoredThru: 0
                         , toPar: 0
                         , differential: 0
                      }
                      var stats = {
                          puttCount: null //x
                         , shortestOnePutt: null //x
                         , longestOnePutt: null //x
                         , gir: null //x
                         , longDriveDistance: null //x
                         , avgDriveDistance: null //x
                         , fairwayOpportunities: null //x
                         , fairwaysHit: null //x
                         , fairwaysMissed: null //x
                         , fairwaysMissedLeft: null //x
                         , fairwaysMissedRight: null //x
                         , fairwaysMissedShort: null //x
                         , fairwaysMissedLong: null //x
                         , fairwayChips: null
                         , upAndDownOpportunities: null //x
                         , upAndDownsHit: null //x
                         , sandSaveOpportunities: null //x
                         , sandSavesHit: null //x
                         , bounceBackOpportunities: null//x
                         , bounceBacksHit: null//x
                         , scrambleOpportunities: null //x
                         , scramblesHit: null //x
                         , callawayScore: null
                         , callawayHandicap: null
                         , holeInOneCount: null//x
                         , albatrossCount: null//x
                         , eagleCount: null//x
                         , birdieCount: null//x
                         , parCount: null//x
                         , bogeyCount: null//x
                         , doubleBogeyCount: null//x
                         , overDoubleBogeyCount: null//x
                         , par3Count: null //x
                         , par4Count: null //x
                         , par5Count: null //x
                         , par3Score: null //x
                         , par4Score: null //x
                         , par5Score: null //x
                         , penaltyStrokes: null //x
                         , exceptionalScoreOdds: null
                      }
                      var wagers = {
                          totalValue1: null
                         , totalValue2: null
                         , totalValue3: null
                         , totalValue4: null
                         , totalValue5: null
                      }
                      var sum = {
                          loops: 0
                         , holesPlayed: 0
                         , driveDistance: 0
                         , driveCount: 0
                      }

                      if ($scope.Temp.isHoleByHole) {
                          for (var x = 0; x < 18; x++) {
                              var isok = true;
                              if (x > 9) {
                                  if ($scope.Outing.game.holeType != app.modules.scoring.constants.holesPlayed.eighteenHoles) {
                                      isok = false;
                                  }
                              }

                              if (isok) {

                                  // loop count
                                  sum.loops++;

                                  // holes played 
                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) > 0) {
                                      sum.holesPlayed++;
                                  }

                                  var total = 0;

                                  // gross
                                  total = Number(score.gross) + (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross));
                                  score.gross = total;
                                  score.net = total;
                                  $scope.GameScore[scoreIndex].gross = score.gross;
                                  $scope.GameScore[scoreIndex].net = score.net;

                                  // front / back
                                  if (x < 9) {
                                      total = Number(score.front9Gross) + (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross));
                                      score.front9Gross = total;
                                      score.front9Net = total;
                                      $scope.GameScore[scoreIndex].front9Gross = score.front9Gross;
                                      $scope.GameScore[scoreIndex].front9Net = score.front9Net;
                                  } else {
                                      total = Number(score.back9Gross) + (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross));
                                      score.back9Gross = total;
                                      score.back9Net = total;
                                      $scope.GameScore[scoreIndex].back9Gross = score.back9Gross;
                                      $scope.GameScore[scoreIndex].back9Net = score.back9Net;
                                  }

                                  // To Par
                                  total = Number(score.toPar) + (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par));
                                  score.toPar = total;
                                  $scope.GameScore[scoreIndex].Temp.toPar = score.toPar;

                                  // Scoring
                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) > 0) {

                                      // Hole In One
                                      if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) == 1) {
                                          stats.holeInOneCount = Number(stats.holeInOneCount) + 1;
                                      }

                                      if (Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) > 0) {
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == -3) {
                                              stats.albatrossCount = Number(stats.albatrossCount) + 1;
                                          }
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == -2) {
                                              stats.eagleCount = Number(stats.eagleCount) + 1;
                                          }
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == -1) {
                                              stats.birdieCount = Number(stats.birdieCount) + 1;
                                          }
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == 0) {
                                              stats.parCount = Number(stats.parCount) + 1;
                                          }
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == 1) {
                                              stats.bogeyCount = Number(stats.bogeyCount) + 1;
                                          }
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == 2) {
                                              stats.doubleBogeyCount = Number(stats.doubleBogeyCount) + 1;
                                          }
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) > 2) {
                                              stats.overDoubleBogeyCount = Number(stats.overDoubleBogeyCount) + 1;
                                          }
                                      }
                                      if (Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == 3) {
                                          stats.par3Count = Number(stats.par3Count) + 1;
                                          stats.par3Score = Number(stats.par3Score) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross);
                                      }
                                      if (Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == 4) {
                                          stats.par4Count = Number(stats.par4Count) + 1;
                                          stats.par4Score = Number(stats.par4Score) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross);
                                      }
                                      if (Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) == 5) {
                                          stats.par5Count = Number(stats.par5Count) + 1;
                                          stats.par5Score = Number(stats.par5Score) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross);
                                      }


                                  }


                                  // Callaway Scoring
                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) > 0 && Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) > 0) {
                                      $scope.GameScore[scoreIndex].gameHoleScores[x].stats.callawayScore = Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross);
                                      // max gross is double par
                                      if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) > Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) * 2) {
                                          $scope.GameScore[scoreIndex].gameHoleScores[x].stats.callawayScore = Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) * 2;
                                      }
                                      total = Number(stats.callawayScore) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.callawayScore);
                                      stats.callawayScore = (total == 0 ? null : total);
                                  }

                                  // Putts
                                  total = Number(stats.puttCount) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttCount);
                                  stats.puttCount = (total == 0 ? null : total);

                                  // Shortest & Longest Putts
                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttCount) == 1) {
                                      if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttLength) > 0) {
                                          if (Number(stats.shortestOnePutt) == 0) {
                                              stats.shortestOnePutt = Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttLength);
                                          } else {
                                              if (stats.shortestOnePutt > Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttLength)) {
                                                  stats.shortestOnePutt = Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttLength);
                                              }
                                          }
                                          if (Number(stats.longestOnePutt) == 0) {
                                              stats.longestOnePutt = Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttLength);
                                          } else {
                                              if (stats.longestOnePutt < Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttLength)) {
                                                  stats.longestOnePutt = Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttLength);
                                              }
                                          }
                                      }
                                  }

                                  // GIR = Par - Putts < par -2;
                                  $scope.GameScore[scoreIndex].gameHoleScores[x].stats.gir = null;
                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) > 0 && Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttCount) > 0 && Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) > 0) {
                                      total = (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttCount)) < Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) - 2 ? 1 : 0;
                                      if (total > 0) {
                                          stats.gir = Number(stats.gir) + 1;
                                          $scope.GameScore[scoreIndex].gameHoleScores[x].stats.gir = true;
                                      } else {
                                          $scope.GameScore[scoreIndex].gameHoleScores[x].stats.gir = false;
                                      }
                                  }

                                  // PenaltyStrokes, nulls only
                                  $scope.GameScore[scoreIndex].gameHoleScores[x].stats.penaltyStrokes = (Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.penaltyStrokes) == 0) ? null : $scope.GameScore[scoreIndex].gameHoleScores[x].stats.penaltyStrokes;
                                  $scope.GameScore[scoreIndex].gameHoleScores[x].stats.penaltyStrokes = (Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.penaltyStrokes) > 10) ? 10 : $scope.GameScore[scoreIndex].gameHoleScores[x].stats.penaltyStrokes;

                                  total = Number(stats.penaltyStrokes) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.penaltyStrokes);
                                  stats.penaltyStrokes = (total == 0 ? null : total);
                                  stats.penaltyStrokes = (stats.penaltyStrokes > 100) ? 100 : stats.penaltyStrokes;

                                  // Long Drive
                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.driveDistance) > 0) {
                                      sum.driveDistance = Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.driveDistance);
                                      sum.driveCount++;

                                      if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.driveDistance) > Number(stats.longDriveDistance)) {
                                          stats.longDriveDistance = Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.driveDistance);
                                      }
                                  }

                                  // Fairway Opps
                                  total = Number(stats.fairwayOpportunities) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir || $scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir != app.modules.scoring.constants.fairwayHitType.noOpportunity ? 1 : 0);
                                  stats.fairwayOpportunities = (total == 0 ? null : total);

                                  // Fairway Hit
                                  total = Number(stats.fairwaysHit) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.hit ? 1 : 0);
                                  stats.fairwaysHit = (total == 0 ? null : total);

                                  // Fairway Missed
                                  total = Number(stats.fairwaysMissed) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missed ? 1 : 0);
                                  stats.fairwaysMissed = (total == 0 ? null : total);

                                  // Fairway Missed Left
                                  total = Number(stats.fairwaysMissedLeft) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedLeft ? 1 : 0);
                                  stats.fairwaysMissedLeft = (total == 0 ? null : total);

                                  // Fairway Missed Right
                                  total = Number(stats.fairwaysMissedRight) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedRight ? 1 : 0);
                                  stats.fairwaysMissedRight = (total == 0 ? null : total);

                                  // Fairway Missed Short
                                  total = Number(stats.fairwaysMissedShort) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedShort ? 1 : 0);
                                  stats.fairwaysMissedShort = (total == 0 ? null : total);

                                  // Fairway Missed Long
                                  total = Number(stats.fairwaysMissedLong) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedLong ? 1 : 0);
                                  stats.fairwaysMissedLong = (total == 0 ? null : total);



                                  // Up & Down Opps
                                  total = Number(stats.upAndDownOpportunities) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.upAndDownOpportunity ? 1 : 0);
                                  stats.upAndDownOpportunities = (total == 0 ? null : total);

                                  // Up & Down Hit
                                  total = Number(stats.upAndDownsHit) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.upAndDownHit ? 1 : 0);
                                  stats.upAndDownsHit = (total == 0 ? null : total);

                                  // Sandy Opps
                                  total = Number(stats.sandSaveOpportunities) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.sandSaveOpportunity ? 1 : 0);
                                  stats.sandSaveOpportunities = (total == 0 ? null : total);

                                  // Sandy Hit
                                  total = Number(stats.sandSavesHit) + ($scope.GameScore[scoreIndex].gameHoleScores[x].stats.sandSaveHit ? 1 : 0);
                                  stats.sandSavesHit = (total == 0 ? null : total);

                                  // Scrambling - Par or better w/o a GIR
                                  $scope.GameScore[scoreIndex].gameHoleScores[x].stats.scrambleOpportunity = null;
                                  $scope.GameScore[scoreIndex].gameHoleScores[x].stats.scrambleHit = null;
                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) > 0 && Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttCount) > 0 && Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) > 0) {
                                      total = (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].gameHoleScores[x].stats.puttCount)) < Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) - 2 ? 1 : 0;
                                      if (total < 1) { // NO GIR -- Opportunity is on the green under par.  But no GIR
                                          stats.scrambleOpportunities = Number(stats.scrambleOpportunities) + 1;
                                          $scope.GameScore[scoreIndex].gameHoleScores[x].stats.scrambleOpportunity = true;
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) < Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) + 1) {
                                              stats.scramblesHit = Number(stats.scramblesHit) + 1;
                                              $scope.GameScore[scoreIndex].gameHoleScores[x].stats.scrambleHit = true;
                                          }
                                      }
                                  }

                                  // Bounce Backs - Hole after Bogey or worse, and score a par or better
                                  if (sum.loops > 1) {
                                      $scope.GameScore[scoreIndex].gameHoleScores[x].stats.bounceBackOpportunity = null;
                                      $scope.GameScore[scoreIndex].gameHoleScores[x].stats.bounceBackHit = null;
                                      if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) > 0 && Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) > 0) { // Score on current hole
                                          if (Number($scope.GameScore[scoreIndex].gameHoleScores[x - 1].gross) > 0 && Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x - 1].par) > 0) { // Score on Previous Hole
                                              if (Number($scope.GameScore[scoreIndex].gameHoleScores[x - 1].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x - 1].par) > 0) { // Bogey or worse on previous hole
                                                  stats.bounceBackOpportunities = Number(stats.bounceBackOpportunities) + 1;
                                                  $scope.GameScore[scoreIndex].gameHoleScores[x].stats.bounceBackOpportunity = true;
                                                  if (Number($scope.GameScore[scoreIndex].gameHoleScores[x].gross) - Number($scope.GameScore[scoreIndex].Temp.gameTee.gameHoles[x].par) < 1) {
                                                      stats.bounceBacksHit = Number(stats.bounceBacksHit) + 1;
                                                      $scope.GameScore[scoreIndex].gameHoleScores[x].stats.bounceBackHit = true;
                                                  }
                                              }
                                          }
                                      }
                                  }
                                  var b = 1;
                                  // Wagers
                                  total = Number(wagers.totalValue1) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].wagers.value1);
                                  wagers.totalValue1 = (total == 0 ? null : total);
                                  // Wagers
                                  total = Number(wagers.totalValue2) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].wagers.value2);
                                  wagers.totalValue2 = (total == 0 ? null : total);
                                  // Wagers
                                  total = Number(wagers.totalValue3) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].wagers.value3);
                                  wagers.totalValue3 = (total == 0 ? null : total);
                                  // Wagers
                                  total = Number(wagers.totalValue4) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].wagers.value4);
                                  wagers.totalValue4 = (total == 0 ? null : total);
                                  // Wagers
                                  total = Number(wagers.totalValue5) + Number($scope.GameScore[scoreIndex].gameHoleScores[x].wagers.value5);
                                  wagers.totalValue5 = (total == 0 ? null : total);
                              }
                          }

                          // Average Drive
                          if (Number(sum.driveCount) > 0 && Number(sum.driveDistance) > 0) {
                              stats.avgDriveDistance = (Number(sum.driveDistance) / Number(sum.driveCount)).toFixed(0);
                              stats.avgDriveDistance = (stats.avgDriveDistance == 0) ? null : stats.avgDriveDistance;
                          }

                          // Differential
                          var tmpScr = score.gross;
                          // Hack a Partial Differential by getting the avg. hole score and multiplying that times 18,9;
                          if ((sum.holesPlayed < 18 && $scope.Outing.game.holeType == app.modules.scoring.constants.holesPlayed.eighteenHoles) || sum.holesPlayed < 9) {
                              if ($scope.Outing.game.holeType == app.modules.scoring.constants.holesPlayed.eighteenHoles) {
                                  tmpScr = (tmpScr / sum.holesPlayed) * 18;
                              } else {
                                  tmpScr = (tmpScr / sum.holesPlayed) * 9;
                              }
                          }

                          // Callaway Score
                          var callawayHandicap = app.modules.scoring.functions.fetchCallawayHandicap($scope.GameScore[scoreIndex].Temp.gameTee.par, stats.callawayScore);
                          var callawayAdjustment = app.modules.scoring.functions.fetchCallawayAdjustment($scope.GameScore[scoreIndex].Temp.gameTee.par, stats.callawayScore);

                          if (callawayHandicap > 0) {
                              // handicap based on the worst holes, so we need to sort the hole scores from worst to best.
                              // except 16, 17, 18
                              var cscores = [];
                              for (var c = 0; c < 15; c++) {
                                  cscores[c] = $scope.GameScore[scoreIndex].gameHoleScores[c].stats.callawayScore;
                              }
                              cscores.sort(function (a, b) { return b - a });

                              // get add up worst scores
                              var worst = 0;
                              if (callawayHandicap == 5) {
                                  worst = Math.round(cscores[0] / 2);
                              }
                              if (callawayHandicap == 10) {
                                  worst = cscores[0];
                              }
                              if (callawayHandicap == 15) {
                                  worst = cscores[0] + Math.round(cscores[1] / 2);
                              }
                              if (callawayHandicap == 20) {
                                  worst = cscores[0] + cscores[1];
                              }
                              if (callawayHandicap == 25) {
                                  worst = cscores[0] + cscores[1] + Math.round(cscores[2] / 2);
                              }
                              if (callawayHandicap == 30) {
                                  worst = cscores[0] + cscores[1] + cscores[2];
                              }
                              if (callawayHandicap == 35) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + Math.round(cscores[3] / 2);
                              }
                              if (callawayHandicap == 40) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3];
                              }
                              if (callawayHandicap == 45) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + Math.round(cscores[4] / 2);
                              }
                              if (callawayHandicap == 50) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + cscores[4];
                              }
                              if (callawayHandicap == 55) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + cscores[4] + Math.round(cscores[5] / 2);
                              }
                              if (callawayHandicap == 60) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + cscores[4] + cscores[5];
                              }

                              // Add adustment
                              stats.callawayHandicap = worst + callawayAdjustment;
                              stats.callawayScore = stats.callawayScore - stats.callawayHandicap;

                          } else {
                              stats.callawayHandicap = 0;
                          }


                          // Update Diff
                          score.differential = ggFunctions.calcDifferential(tmpScr, $scope.GameScore[scoreIndex].Temp.gameTee.rating, $scope.GameScore[scoreIndex].Temp.gameTee.slope);

                          // Apply Score
                          $scope.GameScore[scoreIndex].gross = score.gross;
                          $scope.GameScore[scoreIndex].Temp.toPar = score.toPar;
                          $scope.GameScore[scoreIndex].Temp.differential = score.differential;
                          $scope.GameScore[scoreIndex].scoredThru = sum.holesPlayed;

                          // Apply Stats
                          $scope.GameScore[scoreIndex].stats = stats;

                          // Apply Wagers
                          $scope.GameScore[scoreIndex].wagers = wagers;


                      } // HBH End

                      // Save Local
                      var saveLocal = function (scoreIndex) {
                          var currentLocalScores = JSON.parse(ggStorage.get(ggStorage.keys.outings.inprogress)) || [];
                          var newLocalScores = [];
                          var gameScore = angular.copy($scope.GameScore[scoreIndex]);

                          // Only save it locally if it's changed
                          if (gameScore.Temp && gameScore.Temp.isChanged) {
                              for (var l = 0; l < currentLocalScores.length; l++) {
                                  var localScore = currentLocalScores[l];
                                  if (localScore.id != gameScore.id) {
                                      newLocalScores.push(localScore);
                                  }
                              }
                              newLocalScores.push(gameScore);
                              ggStorage.set(ggStorage.keys.outings.inprogress, newLocalScores);
                          }
                      }

                      saveLocal(scoreIndex);
                      
                      resolve();
                  });
              }
              , saveFullScore: function () {
                  return $q(function (resolve) {

                      // Post Process Score after it has been sent to API
                      var postProcessSavedScore = function (data) {
                          if (data && data.status == "200") {

                              $scope.Temp.saveState.isSaved = true;

                              var updated = data.data.value;
                              // update the correct game score
                              for (var s = 0; s < $scope.GameScore.length; s++) {
                                  for (var u = 0; u < updated.length; u++) {
                                      if ($scope.GameScore[s].id == updated[u].id) {
                                          $scope.GameScore[s].Temp.isChanged = false;

                                          // There is a bug here if the user changes a field on update
                                          //$scope.GameScore[s].gameHoleScores = updated[u].gameHoleScores;

                                      }
                                  }
                              }


                              var removeLocalScore = function (scoreId) {
                                  var currentLocalScores = JSON.parse(ggStorage.get(ggStorage.keys.outings.inprogress)) || [];
                                  var newLocalScores = [];

                                  for (var l = 0; l < currentLocalScores.length; l++) {
                                      var localScore = currentLocalScores[l];
                                      if (scoreId != localScore.id) {
                                          newLocalScores.push(localScore);
                                      }
                                  }

                                  // Set Local Score
                                  ggStorage.set(ggStorage.keys.outings.inprogress, newLocalScores);

                              }

                              // loop throug local scores and remove current view
                              for (var u = 0; u < updated.length; u++) {
                                  removeLocalScore(updated[u].id);
                              }

                              

                              

                              $scope.Temp.isChanged = false;
                              $scope.f.formatScoreObject();
                          }
                      }

                      // Send Score to API
                      var sendGameScoreToAPI = function (data) {
                          return ggScoringSvc.score.batchGameScore(data).then(function (data) {
                              postProcessSavedScore(data);
                          }, function (error) {
                              $scope.PopupAlert.fail("Error", "An error occurred sending the scores to the server.");
                              return;
                          });
                      }

                      var update = {
                          outingId: $scope.Outing.id
                         , teeTime: $scope.Outing.teeTime
                         , scores: []
                      };

                      // loop through each score that needs to be sent to API
                      for (var s = 0; s < $scope.GameScore.length; s++) {
                          if ($scope.GameScore[s].Temp.isChanged) {

                              var gameScore = angular.copy($scope.GameScore[s]);
                              // Dump temp objects
                              delete gameScore.Temp;

                              var aryHoleScores = [];
                              if (gameScore.gameHoleScores) {
                                  for (var h = 0; h < gameScore.gameHoleScores.length; h++) {
                                      if (gameScore.gameHoleScores[h].Temp) {
                                          delete gameScore.gameHoleScores[h].Temp;
                                      }
                                  }

                                  // Clear null wagers
                                  for (var h = 0; h < gameScore.gameHoleScores.length; h++) {
                                      if (gameScore.gameHoleScores[h].wagers && !gameScore.gameHoleScores[h].wagers.value1) {
                                          delete gameScore.gameHoleScores[h].wagers;
                                      }
                                  }

                                  // Update Null Gross = 0 so it saves
                                  for (var h = 0; h < gameScore.gameHoleScores.length; h++) {
                                      if (!gameScore.gameHoleScores[h].gross) {
                                          gameScore.gameHoleScores[h].gross = 0;
                                      }
                                  }

                                  // Remove calculated values from Strokes Gained
                                  angular.forEach(gameScore.gameHoleScores, function handleHoleScore(holeScore) {
                                      angular.forEach(holeScore.strokesGained, function handleStrokeGained(strokeGained) {
                                          delete strokeGained.baseline;
                                          delete strokeGained.strokesGained;
                                      });
                                  });


                                  //gameScore.gameHoleScores = aryHoleScores;
                              }

                              // Wagers
                              if (gameScore.wagers && !gameScore.wagers.totalValue1) {
                                  delete gameScore.wagers;
                              }

                             update.scores.push(gameScore);
                          }

                      }

                      if (update.scores.length > 0) {
                          return sendGameScoreToAPI(update).then(function () {
                              resolve();
                          });
                      } else {
                          resolve();
                      }

                  });
              }
           }
           , formatDateString: function (d) {
               return ggFunctions.formatDateString(d, 'm/d/yyyy', null)
           }

        }

        var vm = $scope.vm = {};
        vm.getGrossTotal = getGrossTotal;
        vm.getNetTotal = getNetTotal;
        vm.getWagerTotal = getWagerTotal;
        vm.postScoresToHandicap = postScoresToHandicap;
        vm.strokesGainedChange = strokesGainedChange;

        /*
        -------------------------------
        Page Request
        -------------------------------
        */

        if ($routeParams && $routeParams.gameScoreId && $routeParams.outingId) {

            // Fetch the Round Information
            var gameScoreId = JSON.parse($routeParams.gameScoreId);
            var outingId = JSON.parse($routeParams.outingId);
            var noLocal = false;
            if ($routeParams.nl) {
                noLocal = true;
            }
            var teeTimeId = 0;
            var isError = false;
            var msg = "";
            var outing = {
                id: outingId
               , game: null
               , gameCourse: null
               , teeTime: null
            }
            var newGameScore = null;


            var fetchSimpleScore = function (data) {
                return ggScoringSvc.score.fetchScoreSimple({ outingId: data.outingId, gameScoreId: data.gameScoreId }).then(function (data) {
                    outing.teeTimeId = 0;
                    if (data.data.value && data.data.value.length > 0) {
                        teeTimeId = data.data.value[0].teeTimeId;
                        outing.teeTime = data.data.value[0].teeTime;
                    }
                    return $q.resolve();
                });
            }

            var fetchTeeTimeDetail = function (data) {
                return ggScoringSvc.score.fetchTeeTimeDetail({ outingId: data.outingId, teeTimeId: data.teeTimeId }).then(function (data) {
                    if (data.data) {
                        outing.game = data.data.game;
                        outing.gameCourse = data.data.gameCourse;
                        outing.players = data.data.players;
                        outing.teams = data.data.teams;
                        outing.scores = data.data.scores;
                    }
                    return $q.resolve();
                });
            }

            var fetchLocalScore = function () {
                if (!noLocal) {
                    var currentLocalScores = JSON.parse(ggStorage.get(ggStorage.keys.outings.inprogress)) || [];
                    for (var l = 0; l < currentLocalScores.length; l++) {
                        for (var s = 0; s < outing.scores.length; s++) {
                            if (outing.scores[s].id == currentLocalScores[l].id) {
                                outing.scores[s] = currentLocalScores[l];
                                $scope.Temp.isChanged = true;
                                break;
                            }
                        }
                    }
                }
                return $q.resolve();
            }


            ggFunctions.toggleProcessing(true);
            fetchSimpleScore({ outingId: outingId, gameScoreId: gameScoreId }).then(function () {
                return fetchTeeTimeDetail({ outingId: outingId, teeTimeId: teeTimeId });
            }).then(function(){
                return fetchLocalScore();
            }).finally(function () {
                if (!isError) {
                    $scope.Outing = outing;
                    $scope.GameScore = outing.scores;

                    // 

                    // Update Temp objects.
                    if (outing.game.gameType == "Team") {
                        $scope.Temp.isTeamScore = true;
                        if (outing.game.scoringType == "Scramble" || outing.game.scoringType == "AlternateShot") {
                            $scope.Temp.isCombinedScore = true;
                        }
                    }

                    $scope.f.formatScoreObject();
                    $scope.Content.init(); // Processing off in init
                } else {
                    gFunctions.toggleProcessing(false);
                    $scope.PopupAlert.fail("Fore!", msg);
                }
            });
        } else {
            var btn = new ggAlertSvc.button;
            btn.name = "Continue";
            btn.path = app.modules.view.routes.intro.path;
            $scope.PopupAlert.fail("Fore!", "Information is missing in the page request.", [btn]);
        }

        function getGrossTotal(score) {
            var scores = score.gameHoleScores;
            return scores.length && scores.map(map).reduce(plus, 0) || null;

            function map(x) {
                return x.gross;
            }
        }

        function getNetTotal(score) {
            var scores = score.gameHoleScores;
            return scores.length && scores.map(map).reduce(plus) || null;

            function map(x) {
                return plus(x.gross, angular.isNumber(x.gross) && angular.isNumber(x.strokes) ? -x.strokes : null);
            }
        }

        function getWagerTotal(score) {
            var scores = score.gameHoleScores;
            return scores.length && scores.map(map).reduce(plus) || null;

            function map(x) {
                return angular.isObject(x.wagers) ? x.wagers.value1 : null;
            }
        }

        function plus(a, b) {
            return !angular.isNumber(a) ? b : !angular.isNumber(b) ? a : a + b;
        }

        function postScoresToHandicap() {
            var
                dialog,
                players,
                scores = $scope.GameScore || [];

            players = scores.map(mapToPlayer);
            if (players.length) {


               app.Member.Session.pageTemplates.fetch("app/scoring/controllers/post-to-hcp-modal.html").then(function (template) {

                  if (isCordova && isCordovaReady) {
                     StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                  }

                  var _postToHcpModal = ngDialog.open({
                     template: template
                     , plain: true
                     , closeByEscape: false
                     , closeByDocument: false
                     , showClose: true
                     , className: "fullscreen"
                     , scope: $scope
                     , controller: PostToHandicapCtrl
                     , controllerAs: 'vm'
                  });

                  _postToHcpModal.closePromise.then(function () {
                     if (isCordova && isCordovaReady) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                     }
                  });

               });


            }

            function PostToHandicapCtrl() {
                var vm = this;
                vm.players = players;
                vm.hasSelected = hasSelected;
                vm.toggle = toggle;
                vm.postScores = postScores;
                vm.processing = false;

                function hasSelected() {
                    return vm.players.some(function (player) { return player.selected; });
                }


                function postScores() {

                    var postScoreToHandicap = function (frm) {
                        return ggScoringSvc.score.postScoreToHandicap(frm.scoreId).then(function (data) {
                            frm.isPostedToHcp = true;
                            frm.selected = false;
                        }, function (fail) {
                            frm.msg = fail.data.error.message;
                            frm.selected = false;
                        });
                    };

                    // Init
                    vm.error = false;
                    vm.processing = true;

                    // Make score id list
                    var scoreIdList = vm.players
                        .filter(function (player) { return player.selected; })
                        .map(function (player) { return player });



                    ggFunctions.qSequence(postScoreToHandicap, scoreIdList).then(function (data) {
                        vm.processing = false;
                    });

                    // Call Api
                    /*
                    postScoreToHandicap(scoreIdList)
                        .then(function (data) {
                           if (data.status == "200" || data.status == "204") {
                              ngDialog.closeAll();
                           }
                           
                        })
                        .catch(function () { vm.error = true; })
                        .finally(function () { vm.processing = false; });
                        */
                }
                function toggle(player) {
                    if (!vm.processing)
                        player.selected = !player.selected;
                }
            }
            function mapToPlayer(score) {
                var
                    player = score.Temp.player,
                    firstName = (player.firstName || '').trim(),
                    lastName = (player.lastName || '').trim();

                return {
                    scoreId: score.id,
                    id: player.memberId,
                    firstName: firstName,
                    lastName: lastName,
                    handicap: player.handicap,
                    handicapType: player.handicap,
                    effectiveOn: player.effectiveOn && ggFunctions.formatDateString(player.effectiveOn, 'm/d/yyyy', null),
                    initials: (firstName.charAt(0) + lastName.charAt(0)).toUpperCase(),
                    selected: true
                    , isPostedToHcp: false
                    , msg : ""
                };
            }
        }

        function strokesGainedChange(Temp) {
            var scores = $scope.GameScore,
                temp = $scope.Temp,
                scoreIndex = temp.scoreIndex,
                holeNumber = temp.currentHoleNumber,
                par = scores[0].Temp.gameTee.gameHoles[holeNumber - 1].par,
                score = scores[scoreIndex],
                holeScore = score.gameHoleScores[holeNumber - 1],
                gross = holeScore.gross;

            temp.isChanged = score.Temp.isChanged = holeScore.Temp.isChanged = true;
            temp.saveState.changedOn = new Date().getTime();

            holeScore.gross = 0; // <== won't update unless different.
            $scope.f.updateHoleGross({ holeNumber: holeNumber, value: gross, par: par, scoreIndex: scoreIndex });
        }
    }
}(angular, app));

